import { useState, useEffect } from "react";
import ModalImageUpload from "../../UI/Modal/ModalImageUpload";
import { useTranslation } from 'react-i18next';
import {CleanUrl} from "../../../utils/cleanUrl";

function FileUploadImage(props) {
    //file upload
    const [uploadError, setUploadError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showImageUpload, setShowImageUpload] = useState(true);
    const [uploadingImage, setUploadingImage] = useState(false);
    const { register, resetField, imagePreview, inputName, setSavedSelectedImage, savedSelectedImage, setValue, setImage, csrfToken } = props;
    const imagePath =  CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
    const [fetchImageURL, setfetchImageURL] = useState("");
    
    useEffect(() => {
        if(savedSelectedImage && savedSelectedImage.find((item) => item.inputName === inputName)) {
            setShowImageUpload(false);
        }

        if(window.pathPrefix !== ""){
            setfetchImageURL(`${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/file/upload/media/promotion_handler_image/field_media_image`);
        } else {
            setfetchImageURL(`${process.env.REACT_APP_BASE_URL}/file/upload/media/promotion_handler_image/field_media_image`);
        }
        
    }, [inputName, savedSelectedImage]);

    const { t } = useTranslation();
    
    const handleImageChange = (e) => {
        setUploadingImage(true);

        const file = e.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10Mb

        if (file) {
            // console.log('File details:', {
            //     name: file.name,
            //     type: file.type,
            //     size: file.size,
            // });

            // Check file size
            if (file.size > maxFileSize) {
                setUploadError(true);
                setErrorMessage(t("File is too big. Max. 10 mb."));
                setUploadingImage(false);
                return;
            }

            // Check file type
            if (
                file.type !== "image/jpg" &&
                file.type !== "image/png" &&
                file.type !== "image/jpeg" &&
                file.type !== "image/heic"
            ) {
                setUploadError(true);
                setErrorMessage(t("This file type is not allowed here. Please read the instructions and try again."));
                setUploadingImage(false);
                return;
            }

            const reader = new FileReader();

            // Add error handler to FileReader
            reader.onerror = () => {
                console.error('FileReader error:', reader.error);
                setErrorMessage(t("An error occurred while reading the file."));
                setUploadingImage(false);
            };

            reader.onload = async () => {
                // console.log('File content successfully read:', reader.result);

                try {
                    // Encode filename to avoid issues with special characters
                    const encodedFileName = encodeURIComponent(file.name);
                    // console.log('Encoded file name:', encodedFileName);

                    // Log headers to debug special character handling
                    const headers = {
                        'Content-Type': 'application/octet-stream',
                        'Content-Disposition': `file; filename="${encodedFileName}"`,
                        'X-CSRF-Token': csrfToken
                    };

                    // console.log('Fetch headers:', headers);

                    // Make the API call
                    const imageResponse = await fetch(fetchImageURL, {
                        method: 'POST',
                        body: file,
                        headers: headers
                    });

                    if (!imageResponse.ok) {
                        throw new Error('Network Error');
                    }

                    const responseData = await imageResponse.json();
                    // console.log('Server response:', responseData);

                    setImage(true);
                    // console.log(responseData.fid[0].value);
                    setValue("image", responseData.fid[0].value);
                    setShowImageUpload(false);
                    setSavedSelectedImage((prevState) => [
                        ...prevState,
                        { file: file, inputName: inputName, data: reader.result },
                    ]);
                    setUploadError(false);
                    setErrorMessage("");
                    setUploadingImage(false);

                } catch (error) {
                    // console.error('Upload error:', error);
                    setErrorMessage(t("Your upload was not successful. Please try again."));
                    setUploadError(true);
                    setUploadingImage(false);
                    resetField("image");
                    setImage(false);
                    return;
                }
            };

            reader.readAsDataURL(file);
        } else {
            // console.warn('No file selected.');
            setUploadingImage(false);
        }
    };

    const handleRemoveImage = () => {
        resetField("image");
        setShowImageUpload(true);
        setUploadError(false);
        setErrorMessage("");
        setSavedSelectedImage((prevState) => prevState.filter(item => item.inputName !== inputName));
        //TODO: remove image and disable submit button again
        setImage(false);
        setValue("image", null);
    };

    const handleModal = () => {
        setShowModal(!showModal);
    }

    // const isRequired = (inputName) => {
    //     return !savedSelectedImage.some(item => item.inputName === inputName);
    // };

    return (
        <div className="pweu-fileUpload-wrapper">
            {uploadError && <div className="upload-error">
                <img className="error-icon" src={imagePath + "error.svg"} alt="" />
                <span>{errorMessage}</span>
            </div>}
            {(!showImageUpload && imagePreview && !uploadError) && 
                <div className="previewImage-wrapper">
                    <img src={savedSelectedImage.find((item) => item.inputName === inputName)?.data} alt="Preview" className="previewImage" />
                </div>
            }
            
            {((showImageUpload) || uploadError) && <label className="fileUpload">
                <input type="file" accept="image/jpg, image/png, image/jpeg, image/heic" id={inputName} name={inputName} {...register("image", { required: true })} onChange={handleImageChange} />
                <span>
                    <img src={imagePath + "fileupload.svg"} alt="" />
                    {t("Upload Photo")}
                </span>
            </label>}

            {uploadingImage && <div style={{marginBlock: "16px"}}>{t("Uploading image...")}</div>}
            
            {(!showImageUpload && !uploadError) && <div className="pweu-uploaded-image">
                    <div className="icon-text-wrapper">
                        <img className="camera-icon" src={imagePath + "fileupload-grey.svg"} alt="" /> 
                        {Object.values(savedSelectedImage).length > 0 && (
                            <span>
                                {savedSelectedImage.find((item) => item.inputName === inputName)?.file.name}
                            </span>
                        )}
                    </div>
                    <div className="icon-text-wrapper">
                        <button type="button" className="btn btn-primary-text delete" onClick={handleRemoveImage}>
                            {t("Delete")}
                            <img className="delete-icon" src={imagePath + "delete.svg"} alt="" /> 
                        </button>
                    </div>
                </div>}
            <button type='button' className='btn btn-primary-text pweu-modal' onClick={handleModal} >{t("How to take a good photo")}</button>
            {showModal && <ModalImageUpload handleModal={handleModal} />}
        </div>
        
    )
}

export default FileUploadImage;
